import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface ITokenRefreshService {
  refreshTokens(): Observable<string>;
}

export const TOKEN_REFRESH_SERVICE = new InjectionToken<ITokenRefreshService>('TOKEN_REFRESH_SERVICE');
